
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.6851 18.2425C19.5124 18.448 19.2081 18.4761 19.0056 18.3052L13.2418 13.4439C13.0392 13.2731 13.015 12.968 13.1877 12.7625C13.3604 12.5569 13.6646 12.5288 13.8672 12.6997L19.631 17.561C19.8336 17.7318 19.8578 18.037 19.6851 18.2425Z","fill":"#222222"}}),_c('path',{attrs:{"d":"M15.2596 7.91026C15.2596 12.0047 11.9537 15.3205 7.87978 15.3205C3.80586 15.3205 0.5 12.0047 0.5 7.91026C0.5 3.81587 3.80586 0.5 7.87978 0.5C11.9537 0.5 15.2596 3.81587 15.2596 7.91026Z","fill":"white","stroke":"#222222","stroke-linecap":"round"}})])
          )
        }
      }
    